export default {
  getCurr: () => {
    return new Date().getTime();
  },
  calcDiff: (startTime, endTime) => {
    return endTime - startTime;
  },
};
